module.exports = "/_next/static/images/41d402cbcfbebb2190bca98784dc6e90-nuapp@1x.png";